import { Injectable } from '@angular/core';
import { PitchPlaylistStore } from './pitch-playlist.store';
import { Recording } from 'src/app/recordings/state';
import { PlaylistItemsResponse } from '../../../../../../../src/app/shared/projects/projects.model';

@Injectable({
  providedIn: 'root'
})
export class PitchPlaylistService {
  constructor(private store: PitchPlaylistStore) {}

  setSongs(pitch): void {
    const { playlist } = pitch;
    const items = playlist.items.map(s => ({
      ...s,
      ...s.recording,
      ...s.recordingDto
    }));

    this.store.set(items);
  }

  updateSongsList(songs): void {
    const items = songs.map(s => ({
      ...s,
      ...s.recording,
      ...s.recordingDto
    }));

    this.store.add(items);
  }

  updatePager(playlistItems: PlaylistItemsResponse) {
    this.store.update(state => ({
      ...state,
      songsPager: {
        ...state.songsPager,
        offset: playlistItems.pageable.offset,
        limit: playlistItems.pageable.pageSize,
        total: playlistItems.totalElements
      }
    }));
  }

  setPitch(pitch): void {
    const {
      expectedExpirationDate,
      lastModifiedTime,
      createdBy,
      createdTime,
      downloadAllSupported,
      playlist,
      hashId,
      showAlbumsArt,
      hasHiResolutionAudio,
      hasMp3,
      userDivision,
      permissionHash
    } = pitch;
    const { name, description, recordingIds } = playlist;

    this.store.update(state => ({
      ...state,
      id: hashId,
      showAlbumsArt,
      name,
      description,
      expectedExpirationDate,
      lastModifiedTime,
      createdBy,
      createdTime,
      hasHiResolutionAudio,
      hasMp3,
      userDivision,
      permissionHash,
      playlist: {
        recordingIds
      },
      ui: {
        ...state.ui,
        downloadAllSupported
      }
    }));
  }

  pitchNotFound(): void {
    this.store.update(state => ({
      ...state,
      ui: {
        ...state.ui,
        pitchNotFound: true,
        downloadAllSupported: false
      }
    }));
  }

  pitchExpired(): void {
    this.store.update(state => ({
      ...state,
      ui: {
        ...state.ui,
        expired: true,
        downloadAllSupported: false
      }
    }));
  }

  setLoading(loading: boolean): void {
    this.store.setLoading(loading);
  }

  setActiveSong(activeSong: Recording): void {
    this.store.update(state => ({
      ...state,
      ui: {
        ...state.ui,
        activeSong
      }
    }));
  }
}
